import { Select } from "@/shared/foundation/primitives";

import { ParameterError } from "./ParameterError";
import { unlessDefault, useParameterRecord } from "./parameterValues";

/**
 * How much the action logs, from the levels that action accepts: they differ
 * per action, and one it does not know can fail every run.
 */
export function LogLevelField({
  name,
  levels,
  defaultLevel,
}: {
  name: string;
  levels: readonly string[];
  defaultLevel: string;
}) {
  const record = useParameterRecord(name);
  const stored = record.get("LOG_LEVEL")?.toUpperCase();
  const items = levels.map((level) => ({ value: level, label: level }));
  return (
    <div data-testid="param-LOG_LEVEL">
      <Select<string>
        items={items}
        value={stored ?? defaultLevel}
        onValueChange={(level) => {
          record.write({
            LOG_LEVEL:
              level === null ? undefined : unlessDefault(level, defaultLevel),
          });
        }}
        label="Log level"
      />
      <ParameterError message={record.error("LOG_LEVEL")} />
    </div>
  );
}
